import React, {useState} from 'react'
import {CartItemContainer, OptionsContainer} from '../ui/command-center-layout'
import {Icon} from '@thryvlabs/maverick'
import {useUserFeatures} from '../../context/user-features-context'
import {formatPrice} from '../../utils/currency-format'
import {thryvSucessServicesIcon} from '../../assets'
import {isThryvBasicCode} from '../../utils/tgp-catalog-flags'

const formatEntitlementName = (entitlement, isCanAusNz) => {
  const baseName =
    isCanAusNz && entitlement.name === 'Custom Video'
      ? 'QuickStart Video'
      : entitlement.name
  const hasQuantity =
    entitlement.quantity !== undefined &&
    entitlement.quantity !== null &&
    entitlement.quantity !== ''

  return hasQuantity ? `${baseName} {${entitlement.quantity}}` : baseName
}

function CartItem({
  title,
  img,
  content = {},
  isCenter,
  isCanAusNz,
  crossedOut,
  handleRemoveItem,
  prodType,
  defaultCentersAndApps,
  selectedCountry,
}) {
  const [open, setOpen] = useState(true)
  const {Listings_BC_MC: frontendListingsBcMc} = useUserFeatures()

  const {
    name,
    entitlements,
    amount,
    quantity,
    unitAmount,
    unit_amount,
    code,
    alreadyIncluded,
  } = content
  const currenciesUnitAmount =
    content?.currencies?.[0]?.unitAmount ??
    content?.currencies?.find(c => c.currency === 'USD')?.unitAmount
  // addon-5-keap-addusers-m2m: amount is always unit price (not subtotal)
  const effectiveUnitAmount =
    unitAmount ??
    unit_amount ??
    currenciesUnitAmount ??
    ((code === 'addon-5-keap-addusers-m2m' ||
      code === 'addon-5-keap-addusers-annual') &&
    Number(amount) > 0
      ? Number(amount)
      : null)
  let existingQuantity = 0
  let existingAmount = 0
  existingQuantity = isCenter
    ? defaultCentersAndApps.centers?.find(item => item.code.includes(code))
        ?.quantity
    : defaultCentersAndApps.apps?.find(item => item.code.includes(code))
        ?.quantity
  existingAmount = isCenter
    ? defaultCentersAndApps.centers?.find(item => item.code.includes(code))
        ?.amount
    : defaultCentersAndApps.apps?.find(item => item.code.includes(code))?.amount
  const isThryvLeads = [
    'tl-mc-5-thryv-m2m',
    'tl-tax-5-thryv-m2m',
    'tl-5-thryv-m2m',
  ].includes(code)
  // Thryv Basic (FULSAS-13789) is a priced-$0 TGP plan, not a legacy free
  // "Basic" plan — it shows $0, not "Free"/"Included", and stays removable.
  const isFree =
    name?.toLowerCase().includes('basic') && !isThryvBasicCode(code)
  const updateQuantityProducts = [
    'addon-socialadsbronze-5-m2m',
    'addon-socialadsgold-5-m2m',
    'addon-socialadssilver-5-m2m',
    'addon-5-keap-addusers-m2m',
    'addon-5-keap-addcontacts-m2m',
    'addon-5-keap-textvoice-m2m',
    'addon-5-keap-addusers-annual',
    'addon-5-keap-addcontacts-annual',
    'addon-5-keap-textvoice-annual',
    'seobase-5-thryv-m2m',
    'addon-5-seopb-m2m',
    'addon-5-seokey-m2m',
    'addon-5-ai-webbuilder',
    'addon-ctn-bninat-m2m',
    'addon-ctn-bninat-annual',
    // FULSAS-13425: Geo Add-On Local Select supports quantity > 1, so it
    // follows the same "remove only reflects the delta above what's
    // already owned" rule as CTN/SEO/Social Ads/Keap add-ons above.
    'addon-geoadd-local-4-m2m',
    'addon-geoadd-local-5-m2m',
  ]
  const noRemovalProducts = [
    'cc_basic-5-thryv-m2m',
    'cc_basicpls-5-thryv-m2m',
    'addon-5-keap-addons',
    'addon-5-keap-addons-annual',
    'appmarket-5-thryv-m2m',
    'vert_clientsvcs-5-thryv-ot',
    'vert_clientsvcs-5-thryv-m2m',
    'vert_mc_clientsvcs-5-thryv-m2m',
    'vert_mc_clientsvcs-5-thryv-ot',
    'vert_mc_web_clientsvcs-5-thryv-m2m',
    'vert_mc_web_clientsvcs-5-thryv-ot',
    'rc_basic-5-thryv-m2m',
    'rc_plus-5-thryv-m2m',
    'rc-5-thryv-m2m',
  ]
  let quantityDifferent = false
  let alreadyIncludedCheck = alreadyIncluded
  if (updateQuantityProducts.includes(code)) {
    if (code === 'seobase-5-thryv-m2m') {
      quantityDifferent =
        Number(existingAmount) * Number(existingQuantity) ==
        Number(amount) * Number(quantity)
    } else {
      quantityDifferent =
        alreadyIncludedCheck &&
        Number(existingAmount) == Number(amount) &&
        Number(existingQuantity) == Number(quantity)
    }
  }
  if (updateQuantityProducts.includes(code)) {
    alreadyIncludedCheck = quantityDifferent
  }
  const showRemoveButton =
    !alreadyIncludedCheck &&
    code &&
    prodType !== 'OneTimeFee' &&
    !noRemovalProducts.includes(code) &&
    !isFree
      ? true
      : false
  const hasOptions = entitlements?.length > 0
  const planCategory =
    title && title === 'AEO & SEO'
      ? ''
      : name?.replace(
          /.*?(Pro Enhanced|Professional|Pro|Plus|Unlimited).*/g,
          '$1',
        )

  const isCC = title === 'My Account'
  // Bundle parent addon-5-keap-addons shows "Included" like Thryv Add-Ons
  const showAddonPrice =
    (parseInt(amount || 0) !== 0 || code === 'addon-5-leadslift-bni-m2m') &&
    code !== 'addon-5-keap-addons'
  const shouldShowSeoAddonQuantity = [
    'SEO Keywords',
    'AEO & SEO PowerBoost',
  ].includes(title)

  if (title.includes('Fee')) {
    img = undefined
  }

  const handleItemRemove = e => {
    handleRemoveItem(code, prodType)
  }

  if (content.groupTitle === 'Thryv Success Services') {
    isCenter = true
    img = thryvSucessServicesIcon
    title = content.groupTitle
  }

  if (isCenter) {
    return (
      <>
        <CartItemContainer
          hasOptions={hasOptions}
          data-testid={`cart-item-${title}`}
        >
          <div className="content">
            <div className="logo-container">
              <img
                src={img}
                height={32}
                width={32}
                alt="center logo"
                className="logo"
              />
            </div>
            <div>
              <p className="m-0 dark-text">{title}</p>
              {content ? (
                <p className="m-0 light-text">
                  {isFree ? 'Free' : isThryvLeads ? '' : planCategory}
                </p>
              ) : (
                <p className="m-0 light-text">None Selected</p>
              )}
            </div>
          </div>
          {content ? (
            <p className="m-0 dark-text">
              {isFree
                ? 'Included'
                : formatPrice(amount, quantity, title, selectedCountry)}
            </p>
          ) : (
            <p className="m-0 dark-text">None</p>
          )}
          {showRemoveButton ? (
            <div>
              <button onClick={handleItemRemove}>
                <Icon
                  type={'regular'}
                  variant={`x`}
                  height={'15'}
                  width={'15'}
                  color={'#FF6100'}
                />
              </button>
            </div>
          ) : (
            ''
          )}
        </CartItemContainer>
        {!isCC && hasOptions && (
          <OptionsContainer>
            <button
              className="w-full"
              onClick={() => setOpen(prevVal => !prevVal)}
              aria-describedby={`Click to access cart content below.`}
            >
              <div className={`w-full flex cursor-pointer`}>
                <p className="m-0 mr-1" style={{color: '#A3A5A7'}}>
                  OPTIONS
                </p>
                <div className="flex items-center text-center gap-4">
                  <Icon
                    type={'solid'}
                    variant={`caretDown`}
                    className={`fill-current text-thryv-black-500 -rotate-90 ${
                      open && 'rotate-0'
                    } transition-all duration-300 ease-in-out cursor-pointer`}
                    height={'8'}
                    width={'8'}
                  />
                </div>
              </div>
            </button>
            <div
              className={`${
                !open
                  ? 'hidden opacity-0 scale-0 transition-all duration-500 ease-in-out '
                  : 'visible opacity-100 scale-100 transition-all duration-700 ease-in-out '
              } mt-[8px]`}
            >
              {entitlements.map(option => (
                <React.Fragment key={option.id}>
                  <div className="d-flex justify-content-between">
                    <p className="m-0 dark-text">
                      {formatEntitlementName(option, isCanAusNz)}
                    </p>
                    <p className="m-0 dark-text">
                      {option.name === 'Workforce Center Employees' ||
                      option.name === 'Workforce Center Contractors '
                        ? 'Varies'
                        : formatPrice(
                            option.amount || 0,
                            option.quantity,
                            option.name,
                            selectedCountry,
                          )}
                    </p>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </OptionsContainer>
        )}
      </>
    )
  }
  return (
    <CartItemContainer data-testid={`cart-item-${title}`}>
      <div className="content">
        <div className="logo-container">
          {img !== undefined ? (
            <img
              src={img}
              height={32}
              width={32}
              alt="center logo"
              className="logo"
            />
          ) : (
            <span style={{paddingRight: '33.5px'}} />
          )}
        </div>
        <p
          className="m-0 dark-text"
          style={{
            color: crossedOut && frontendListingsBcMc ? '#808080' : '',
            textDecorationLine:
              crossedOut && frontendListingsBcMc ? 'line-through' : 'none',
          }}
        >
          {title}{' '}
          {quantity > 1 &&
            (!title.includes('SEO') || shouldShowSeoAddonQuantity) &&
            `(${quantity}x)`}
        </p>
      </div>
      <p className="m-0 dark-text">
        {showAddonPrice
          ? (() => {
              if (crossedOut) return formatPrice(0, 1, title, selectedCountry)
              if (title.includes('Lift'))
                return formatPrice(unitAmount, quantity, title, selectedCountry)
              if (code === 'addon-5-keap-addusers-m2m') {
                if (effectiveUnitAmount != null) {
                  return formatPrice(
                    effectiveUnitAmount,
                    quantity,
                    title,
                    selectedCountry,
                  )
                }
                // amount is unit price; formatPrice multiplies by quantity
                return formatPrice(
                  amount,
                  quantity || 1,
                  title,
                  selectedCountry,
                )
              }
              return formatPrice(amount, quantity, title, selectedCountry)
            })()
          : 'Included'}
      </p>
      {showRemoveButton ? (
        <div>
          <button onClick={handleItemRemove}>
            <Icon
              type={'regular'}
              variant={`x`}
              height={'15'}
              width={'15'}
              color={'#FF6100'}
            />
          </button>
        </div>
      ) : (
        ''
      )}
    </CartItemContainer>
  )
}

export {CartItem}
